import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import interpolateValue from '../utils/interpolators/value';
import interpolateRound from '../utils/interpolators/round';
import constant from '../utils/constant';
import enUS from '../../../../fc-utils/src/number-converter/locales/en-US';
import { NumberConverter } from '../../../../fc-utils/src/number-converter';
var count = 0;
var UNIT = [0, 1];

function bimap(a, b, c, d) {
  var e, f;
  return a[0] > a[1] ? (e = c(a[1], a[0]), f = d(b[1], b[0])) : (e = c(a[0], a[1]), f = d(b[0], b[1])), function (a) {
    return f(e(a));
  };
}

function copyScale(a, b) {
  return b.setInterpolate(a.getInterpolate()).setClamp(a.getClamp()).setDomain(a.getDomain()).setRange(a.getRange());
}

function deInterpolateLinear(a, b) {
  a = +a, b = +b;
  var c = b - a;
  return c ? function (b) {
    return (b - a) / c;
  } : constant(c);
}

function deInterpolateClamp(a) {
  return function (b, c) {
    b = +b, c = +c;
    var d = a(b, c);
    return function (a) {
      return a <= b ? 0 : a >= c ? 1 : d(a);
    };
  };
}

function reInterpolateClamp(a) {
  return function (b, c) {
    b = +b, c = +c;
    var d = a(b, c);
    return function (a) {
      return 0 >= a ? b : 1 <= a ? c : d(a);
    };
  };
}

var ScaleContinuous =
/*#__PURE__*/
function () {
  function ScaleContinuous(a, b) {
    _classCallCheck(this, ScaleContinuous);

    this.domain = UNIT, this.range = UNIT, this.deInterpolate = a, this.reInterpolate = b, this.interpolate = interpolateValue, this.clamp = !1, this.input = null, this.output = null, this.locale = enUS, this._localeConverter = new NumberConverter(enUS), this._rescale(), this._id = 'scale_' + count++;
  }

  _createClass(ScaleContinuous, [{
    key: "_rescale",
    value: function _rescale() {
      return this.input = null, this.output = null, this;
    }
  }, {
    key: "setDomain",
    value: function setDomain() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : UNIT;
      return this.domain = a.map(Number), this._rescale();
    }
  }, {
    key: "getDomain",
    value: function getDomain() {
      return this.domain.slice();
    }
  }, {
    key: "setRange",
    value: function setRange() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : UNIT;
      return this.range = a.slice(), this._rescale();
    }
  }, {
    key: "getRange",
    value: function getRange() {
      return this.range.slice();
    }
  }, {
    key: "setInterpolate",
    value: function setInterpolate() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : interpolateValue;
      return this.interpolate = a, this._rescale();
    }
  }, {
    key: "getInterpolate",
    value: function getInterpolate() {
      return this.interpolate;
    }
  }, {
    key: "setClamp",
    value: function setClamp() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return this.clamp = !!a, this._rescale();
    }
  }, {
    key: "getClamp",
    value: function getClamp() {
      return this.clamp;
    }
  }, {
    key: "rangeRound",
    value: function rangeRound() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : UNIT;
      return this.range = a.slice(), this.interpolate = interpolateRound, this._rescale();
    }
  }, {
    key: "getRangeValue",
    value: function getRangeValue(a) {
      a = null === a ? void 0 : a;
      var b = this.getClamp(),
          c = b ? deInterpolateClamp(this.deInterpolate) : this.deInterpolate;
      return this.output || (this.output = bimap(this.getDomain(), this.getRange(), c, this.interpolate)), this.output(+a);
    }
  }, {
    key: "getDomainValue",
    value: function getDomainValue(a) {
      var b = this.getClamp(),
          c = b ? reInterpolateClamp(this.reInterpolate) : this.reInterpolate;
      return this.input || (this.input = bimap(this.getRange(), this.getDomain(), deInterpolateLinear, c)), this.input(+a);
    }
  }, {
    key: "setLocale",
    value: function setLocale() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : enUS;
      return this.locale = a, this._localeConverter = new NumberConverter(a), this;
    }
  }, {
    key: "getLocale",
    value: function getLocale() {
      return this.locale;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this._id;
    }
  }]);

  return ScaleContinuous;
}();

export { copyScale, deInterpolateLinear, bimap };
export default ScaleContinuous;